import * as urls from '@apps-common/js-client/api/urls';
import request, {setAppHeader} from '@apps-common/js-client/api/request';
import {LicenseInfo} from '@mui/x-license';
import {issuers} from '@apps-common/auth';
import {setGraneroTarget} from '@apps-common/geocorn-sdk/api';

// MUI X Setup
LicenseInfo.setLicenseKey(import.meta.env.VITE_MATERIAL_UI_X_KEY);

export const API_TARGETS = {
  prod: 'prod',
  staging: 'staging',
};

export const API_TARGET = import.meta.env.VITE_API_TARGET;

const AUTH_ISSUERS = {
  [API_TARGETS.prod]: issuers.production,
  [API_TARGETS.staging]: issuers.staging,
};

export const AUTH_ISSUER = AUTH_ISSUERS[API_TARGET];

const AUTH_CLIENT_IDS = {
  [API_TARGETS.prod]: import.meta.env.VITE_AUTH_CLIENT_ID_PROD_DEV,
  [API_TARGETS.staging]: import.meta.env.VITE_AUTH_CLIENT_ID_STAGING_DEV,
};

export const AUTH_CLIENT_ID =
  import.meta.env.VITE_AUTH_CLIENT_ID || AUTH_CLIENT_IDS[API_TARGET];

// configure the Granero target environment
export const GRANERO_BASE_URL = setGraneroTarget(
  import.meta.env.VITE_GRANERO_TARGET || 'live'
);

export const isDev = import.meta.env.MODE === 'development';

export const API_BASE_URL =
  {
    [API_TARGETS.prod]: 'https://api.planet.com',
    [API_TARGETS.staging]: 'https://api.staging.planet-labs.com',
  }[API_TARGET] || import.meta.env.VITE_API_BASE_URL;

// this injects the value as the base url for all requests
urls.setBase(API_BASE_URL);
request.defaults.baseUrl = API_BASE_URL;

export const DATA_API_URL =
  import.meta.env.VITE_DATA_API_URL || `${API_BASE_URL}/data/v1`;

export const ORDERS_ENDPOINT =
  import.meta.env.VITE_ORDERS_ENDPOINT ||
  `${API_BASE_URL}/compute/ops/orders/v2`;
export const ORDERS_POSTFIX = 'Explorer';

export const BING_TOKEN = import.meta.env.VITE_BING_TOKEN;
export const MAPBOX_ACCESS_TOKEN = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN;

export const TILES_BASE_URL = import.meta.env.VITE_TILES_BASE_URL;

export const WEBTILES_HOSTNAME =
  import.meta.env.WEBTILES_HOSTNAME ||
  {
    [API_TARGETS.prod]: 'https://tiles{0-3}.planet.com',
    [API_TARGETS.staging]: 'https://webtiles.staging.planet-labs.com',
  }[API_TARGET];

export const YATS_HOSTNAME =
  import.meta.env.YATS_HOSTNAME ||
  {
    [API_TARGETS.prod]: 'https://tiles{0-3}.planet.com',
    [API_TARGETS.staging]: 'https://yats.staging.planet-labs.com',
  }[API_TARGET];

export const TEST_USERNAME = import.meta.env.TEST_USERNAME;
export const TEST_PASSWORD = import.meta.env.TEST_PASSWORD;

export const STILES_LAYER_URL = `${YATS_HOSTNAME}${
  import.meta.env.VITE_BASEMAPS_API_BASE
}/stile/global/{z}/{x}/{y}.png`;

export const TASKING_URL = import.meta.env.VITE_TASKING_URL;

export const BLOBZ_API_URL =
  import.meta.env.VITE_BLOBZ_API_URL || `${API_BASE_URL}/apps/v0/b`;

export const PDA_ADMIN_URL =
  import.meta.env.VITE_PDA_ADMIN_URL ||
  `${API_BASE_URL}${import.meta.env.VITE_PDA_ADMIN_BASE}`;

setAppHeader('features-manager', [PDA_ADMIN_URL]);
